import { render, staticRenderFns } from "./HeaderColumn.vue?vue&type=template&id=357754e6"
import script from "./HeaderColumn.vue?vue&type=script&lang=js"
export * from "./HeaderColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports